$( document ).ready(function() {
  
  $('.single-slider .slide-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay:true
  });

  $('.product-slider .product-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
   {
      breakpoint: 1360,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});


    $(document).ready(function(){
	$('.search_click').on('click', function() {
		$('body').addClass('search-active');	  	
	});
	
	$('.search_close').on('click', function() {
		$('body').removeClass('search-active');		
	});
});
  


});

